export const currentQuestionSelector = (state) => {
  if (state.reasonForm.currentQuestion) {
    return state.reasonForm.form.questions.find(question => question.id === state.reasonForm.currentQuestion);
  }

  return null;
};



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./main/selectors/reason-form-selectors.ts